const statusTypes = [
  { value: 1, label: 'Pending' },
  { value: 2, label: 'Done' },
];

export default statusTypes;
